module.exports = __webpack_public_path__ + "img/concursos1.9dc8dca9.png";